export default "https://housescan.app.solease.nl/static/media/water_pump_2.f5413b64.svg";